import { Button, Card, Modal } from '@playerbase/ui';

// Confirmation step for the "Remove from this pattern" action on a
// single mention. Mirrors dismiss-pattern-confirm-modal so the surface
// reads the same way across all studio interventions on a pattern card.

interface RemoveMentionConfirmModalProps {
  open: boolean;
  aspectId: string;
  busy: boolean;
  error: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export function RemoveMentionConfirmModal({
  open,
  aspectId,
  busy,
  error,
  onConfirm,
  onCancel,
}: RemoveMentionConfirmModalProps): JSX.Element {
  const labelId = `remove-mention-${aspectId}`;
  return (
    <Modal
      open={open}
      onClose={onCancel}
      labelledById={labelId}
      busy={busy}
      size="sm"
    >
      <Card>
        <Card.Header>
          <Card.Title id={labelId}>Remove mention</Card.Title>
          <Card.Description>
            Remove this mention from the pattern? The mention stays in the
            feed; it just stops being grouped with this pattern.
          </Card.Description>
        </Card.Header>
        {error !== null && (
          <Card.Content>
            <p className="text-sm text-danger-text">{error}</p>
          </Card.Content>
        )}
        <Card.Footer>
          <Button variant="ghost" onClick={onCancel} disabled={busy}>
            Cancel
          </Button>
          <Button variant="danger" onClick={onConfirm} disabled={busy}>
            {busy ? 'Removing…' : 'Remove mention'}
          </Button>
        </Card.Footer>
      </Card>
    </Modal>
  );
}
